export const sansthaUserExportColumns = [
	{ label: 'Sr No', key: 'index' },

	{
		label: 'First Name',
		render: u => u?.firstName || '',
	},
	{
		label: 'Last Name',
		render: u => u?.lastName || '',
	},
	{
		label: 'Mobile',
		render: u => u?.mobile || '',
	},
	{
		label: 'Email',
		render: u => u?.email || '',
	},
	{
		label: 'Native Address',
		render: u => `${u?.nativePlaceAddress || ''} ${u?.nativeArea || ''}`,
	},
	{
		label: 'Present Address',
		render: u => `${u?.presentAddress || ''} ${u?.presentnativeArea || ''}`,
	},
	{
		label: 'Joined Date',
		render: u => (u?.joinedHubDate ? new Date(u.joinedHubDate).toLocaleDateString() : ''),
	},
	{
		label: 'Membership Start',
		render: u =>
			u?.joinedSanstha?.[0]?.membershipStartDate
				? new Date(u.joinedSanstha[0].membershipStartDate).toLocaleDateString()
				: '',
	},
	{
		label: 'Membership End',
		render: u =>
			u?.joinedSanstha?.[0]?.membershipEndDate
				? new Date(u.joinedSanstha[0].membershipEndDate).toLocaleDateString()
				: '',
	},
	{
		label: 'Membership Type',
		render: u => u?.joinedSanstha?.[0]?.membershipType || '',
	},
	{
		label: 'Premium',
		render: u => (u?.premium ? 'Yes' : 'No'),
	},
]
